import { LanguageEnums, LanguageValues } from '@nw/shared/config'

export const getLanguageEnum = (language: string): string => {
  const matchingLanguageEntry = Object.entries(LanguageValues).find(
    ([, value]) => value === language
  )
  if (matchingLanguageEntry) {
    const [key] = matchingLanguageEntry
    return LanguageEnums[key]
  }
  return ''
}

export const getPreferredLanguagesEnums = (language: string): string[] => {
  const languageEnum = getLanguageEnum(language)
  return languageEnum ? [languageEnum] : []
}

export const getPreferredLanguageValueBasedOnEnum = (
  languageEnum: string
): string => {
  const matchingLanguageEntry = Object.entries(LanguageEnums).find(
    ([, value]) => value === languageEnum
  )
  if (matchingLanguageEntry) {
    const [key] = matchingLanguageEntry
    return LanguageValues[key]
  }
  return ''
}

export const getSelectedSlotLanguageEnumBasedOnPreferredWebinarSlot = (
  preferredWebinarSlot: string | undefined
): string | undefined => {
  if (preferredWebinarSlot && preferredWebinarSlot.includes(' - ')) {
    const selectedSlotLanguage = preferredWebinarSlot.split(' - ')[0]
    return getLanguageEnum(selectedSlotLanguage)
  }
  return undefined
}
